import { HeaderPanel } from '../../HeaderPanel';
import React from 'react';
import { headerPanelOptions } from './panelSettings';
import { EntityProperties } from './EntityProperties';
import { DataPair } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/ContextData/DataPair';

interface PropertiesPanelProps {
  properties?: DataPair[];
}

export function PropertiesPanel({ properties }: PropertiesPanelProps) {
  return (
    <HeaderPanel {...headerPanelOptions('secondary', 'Properties')}>
      <EntityProperties properties={properties} />
    </HeaderPanel>
  );
}
